/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OWGameResponse } from './OWGameResponse';
import {
    OWGameResponseFromJSON,
    OWGameResponseFromJSONTyped,
    OWGameResponseToJSON,
    OWGameResponseToJSONTyped,
} from './OWGameResponse';

/**
 * 
 * @export
 * @interface ChallengeInstantReward
 */
export interface ChallengeInstantReward {
    /**
     * 
     * @type {string}
     * @memberof ChallengeInstantReward
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeInstantReward
     */
    questName: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeInstantReward
     */
    questDescription: string;
    /**
     * 
     * @type {number}
     * @memberof ChallengeInstantReward
     */
    target: number;
    /**
     * 
     * @type {Array<OWGameResponse>}
     * @memberof ChallengeInstantReward
     */
    games: Array<OWGameResponse>;
}

/**
 * Check if a given object implements the ChallengeInstantReward interface.
 */
export function instanceOfChallengeInstantReward(value: object): value is ChallengeInstantReward {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('questName' in value) || value['questName'] === undefined) return false;
    if (!('questDescription' in value) || value['questDescription'] === undefined) return false;
    if (!('target' in value) || value['target'] === undefined) return false;
    if (!('games' in value) || value['games'] === undefined) return false;
    return true;
}

export function ChallengeInstantRewardFromJSON(json: any): ChallengeInstantReward {
    return ChallengeInstantRewardFromJSONTyped(json, false);
}

export function ChallengeInstantRewardFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeInstantReward {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'questName': json['questName'],
        'questDescription': json['questDescription'],
        'target': json['target'],
        'games': ((json['games'] as Array<any>).map(OWGameResponseFromJSON)),
    };
}

export function ChallengeInstantRewardToJSON(json: any): ChallengeInstantReward {
    return ChallengeInstantRewardToJSONTyped(json, false);
}

export function ChallengeInstantRewardToJSONTyped(value?: ChallengeInstantReward | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'questName': value['questName'],
        'questDescription': value['questDescription'],
        'target': value['target'],
        'games': ((value['games'] as Array<any>).map(OWGameResponseToJSON)),
    };
}

